<label (click)="toggle()">
    <input id="{{optionId}}"  type="radio" [value]="option.value" name="{{name}}" [checked]="isChecked()" />
    <span *ngIf="!toTranslate">{{ option.label }}</span>
    <span *ngIf="toTranslate">{{ option.label | uppercase | translate }}</span>
</label>
